module.exports = __webpack_public_path__ + "static/COVID-Screener-Image-8a9fe81bbd36eb4220b497e748fa053c.png";